import React, {Component} from 'react';
import {Image, Row} from 'react-bootstrap';
import LazyLoad, {forceCheck} from 'react-lazyload';
import "./style.css";

const MyLoader = props => (<div style={{backgroundColor:'#f1f2f3',width: props.width ? props.width : '100%', height: props.height ? props.height : '100%', zIndex: '2000', position: 'absolute', left: 0}}/>);

const CategoryCard = ({category, index, handleCategorySelection,on_drag_start,on_drag,on_drag_end,on_click}) => {

    return (
        <div style={{paddingBottom: 27, width: '279px'}} key={'category_card_' + index}>
            <Row style={{paddingLeft: 12, paddingRight: 12}}>
                    <span style={{"float": "left", fontFamily: 'Montserrat', fontSize: 14}}>
                        {category.displayName}
                    </span>
                <span
                    style={{"float": "right", fontFamily: 'Montserrat', fontSize: 14, cursor: "pointer"}}
                    onClick={() => handleCategorySelection(category.type)}
                >
                    All
                </span>
            </Row>
            <div
                style={{
                    display: 'flex',
                    flexFlow: 'row',
                    overflowX: 'scroll',
                    'paddingLeft': '25px',
                    'paddingRight': '25px',
                    "paddingTop": "10px",
                    "paddingBottom": "10px",
                    width: '100%'
                }}
            >
                {category.data.map((element, idx) =>
                    (<div key={idx} className="loader_strict_dimensions unselectable">
                        <LazyLoad overflow={true}>
                        <MyLoader width={75} height={75}/>
                        <Image
                            onLoad={(e) => {
                                e.target.style.display = 'block';
                                e.target.parentElement.children[0].style.display = 'none'
                            }}
                            style={{display: 'none'}}
                            className="design-resources-inner-component"
                            key={'panelImages' + idx}
                            onDragStart={(e) => {
                                if (category.on_drag_start) {
                                    category.on_drag_start(element, e)
                                } else {
                                    on_drag_start(element, e)
                                }
                            }}
                            onDrag={(e) => {
                                if (category.on_drag) {
                                    category.on_drag(element, e)
                                } else {
                                    on_drag(element, e)
                                }
                            }}
                            onDragEnd={(e) => {
                                if (category.on_drag_end) {
                                    category.on_drag_end(element, e)
                                } else {
                                    on_drag_end(element, e)
                                }
                            }}
                            onClick={(e) => {
                                if (category.on_click) {
                                    category.on_click(element, e)
                                } else {
                                    on_click(element, e)
                                }
                            }}
                            src={element.src.indexOf('data:image') > -1 || element.src.indexOf('http') > -1 || element.src.indexOf('blob:') > -1 ? element.src : global.config.server_path + element.src}
                            alt={'Image Not Found'}
                            crossOrigin="anonymous"
                            />
                        </LazyLoad>
                    </div>)
                )}
            </div>
        </div>
    )
};

class ElementsHomePanel extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        document.getElementById('elements-panel-container').onscroll = e => forceCheck();
    }

    GenerateAllResourcesView = () => {
        let view = [];
        for (let i = 0; i < this.props.categories.length; i++) {
            view.push(
                <CategoryCard
                    category={this.props.categories[i]}
                    on_click={this.props.on_click}
                    on_drag_start={this.props.on_drag_start}
                    on_drag={this.props.on_drag}
                    on_drag_end={this.props.on_drag_end}
                    index={i}
                    handleCategorySelection={this.props.handleCategorySelection}
                />)
        }
        return view;
    };

    render() {
        return (
            <div id='elements-panel-container' style={{'width': '100%', 'height': '100%', 'paddingRight': '20px', overflowY: 'auto'}}>
                <this.GenerateAllResourcesView/>
                <div style={{marginBottom: 75}}/>
            </div>
        );
    }
}


export default ElementsHomePanel;